export enum BenefitStatus {
    ACTIVE = "ACTIVE",
    TERMINATED = "TERMINATED",
    UNKNOWN = "UNKNOWN",
    ACTIVE_BENEFIT_LOCKED = "ACTIVE_BENEFIT_LOCKED"
}